export const CLASSIC = 'Classic'
export const MINI = 'Mini'

export type PuzzleFormat = typeof CLASSIC | typeof MINI
